module.exports = __webpack_public_path__ + "media/images/850/insomnia_moon_dark_skies-e81927354f781cc834c3bf281b074807.jpg";